<template>
  <section class="report-section">

    <h3>1.1 Fabbisogno energetico TEP</h3>

    <table class="grid" style="margin-top:70px;">
      <tr>
        <td class="col-small">
          <div class="pie-wrap">
            <apexchart type="pie" :options="pie1_options" :series="pie1_data"></apexchart>
          </div>
        </td>
        <td>
          <b-table :items="table1" :fields="fields">
            <template slot="color" slot-scope="row">
              <span class="legend" :style="{ color: $store.state.colors[row.index] }">■</span>
            </template>
            <template slot="TEP" slot-scope="row">
              {{ f(row.item.TEP) }}
            </template>
            <template slot="value" slot-scope="row">
              {{ f(row.item.value) }}
            </template>
            <template slot="cost" slot-scope="row">
              {{ f(row.item.cost) }}
            </template>
          </b-table>
        </td>
      </tr>
    </table>

  </section>
</template>

<script>
export default {
  name: "Fabbisogno",
  props: ['tep'],
  data() {
    return {
      vectors: {},
      table1: [],
      pieOptions: {
        colors: this.$store.state.colors,
        chart: {
          animations: false,
          width: 300
        },
        labels: [],
        tooltip: {
          y: {
            formatter: v => {
              return v ? this.f(v) + " [kWh]" : ""
            }
          }
        },
        legend: {
          show: false
        }
      },
      pie1_options: {},
      pie1_data: [],
      fields: [
        { key: 'color', label: ''},
        { key: 'name', label: 'Vettore' },
        { key: 'value', label: 'Consumo' },
        { key: 'mu', label: 'U.M.' },
        { key: 'perc', label: '%' },
        { key: 'TEP', label: 'TEP' },
        { key: 'cost', label: '€' }
      ]
    }
  },

  created() {
    this.reload()
  },

  methods: {
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
    reload() {

      var total = 0
      this.vectors = {}
      this.tep.forEach(item => {

        if(item.parentCode)
          return

        if(! this.vectors[item.vector]) {
          this.vectors[item.vector] = { TEP: 0, value: 0, cost: 0 }
        }

        this.vectors[item.vector].TEP += item.TEP
        this.vectors[item.vector].value += item.value
        this.vectors[item.vector].cost += item.cost

        total += item.TEP
      })

      let pie1_options = _.cloneDeep(this.pieOptions)

      this.pie1_data = []
      this.table1 = []

      for(var v in this.vectors) {
        console.log(v)
        this.vectors[v].mu = this.$store.state.vectors.list.find(vv => vv.code == v).mu
        this.vectors[v].name = this.$store.state.vectors.list.find(vv => vv.code == v).name
        this.vectors[v].perc = ((this.vectors[v].TEP / total * 100).toFixed(2) + "%").replace(/\.00/, '')
        this.table1.push(this.vectors[v])
        this.pie1_data.push(this.vectors[v].TEP)
        pie1_options.labels.push(v)
      }
      this.pie1_options = pie1_options

    },
  },
  watch: {
    tep() {
      this.reload()
    }
  }
}
</script>

<style>
@media print {
  .apexcharts-legend-marker:before {
    content: "\25A0";
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    line-height: 12px;
    font-size: 24px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Report/A_Fabbisogno.vue